import Vue from 'vue'
import DialogComponent from '../components/Dialog.vue'

const Dialog = {
  install(Vue) {
    const DialogConstructor = Vue.extend(DialogComponent)
    const instance = new DialogConstructor()
    instance.$mount(document.createElement('div'))
    document.body.appendChild(instance.$el)

    const dialog = {
      alert(options) {
        if (typeof options === 'string') {
          options = { message: options }
        }
        return new Promise((resolve) => {
          instance.alert({
            title: options.title || '',
            message: options.message || '',
            type: options.type || 'info',
            okText: options.okText || '确定',
            onClose: () => resolve()
          })
        })
      },

      confirm(options) {
        if (typeof options === 'string') {
          options = { message: options }
        }
        return new Promise((resolve, reject) => {
          instance.confirm({
            title: options.title || '提示',
            message: options.message || '',
            okText: options.okText || '确认',
            cancelText: options.cancelText || '取消',
            onOk: () => resolve(),
            onCancel: () => reject()
          })
        })
      },

      tips(options) {
        if (typeof options === 'string') {
          options = { message: options }
        }
        instance.tips({
          message: options.message || '',
          type: options.type || 'success',
          position: options.position || 'top-center',
          duration: options.duration || 2000
        })
      },

      loading(options) {
        if (typeof options === 'string') {
          options = { text: options }
        }
        instance.loading({
          text: options.text || '加载中...'
        })
      },

      closeLoading() {
        instance.closeLoading()
      }
    }

    Vue.prototype.$dialog = dialog
  }
}

export default Dialog
